import React from 'react';
import { RangeInput, RangeValue } from '../RangeInput';
import { usePriceRange } from './PriceRange.controller';

type PriceRangeArgs = {
  showSlider?: boolean;
  value: RangeValue;
  onChange?: (value: RangeValue) => void;
};

const PriceRange: React.FC<PriceRangeArgs> = ({ value, onChange }) => {
  const { currentValue, handleChange } = usePriceRange({ value, onChange });
  return <RangeInput unit={'$'} minLabel={'Min'} maxLabel={'Max'} minPlaceholder={'0'} maxPlaceholder={'1000+'} minValue={0} value={currentValue} onChange={handleChange} />;
};

export { PriceRange, PriceRangeArgs };
